<!--采购下单-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          :allowClear="false"
          slot="organizationCode"
          :value.sync="queryParams.organizationCode"
          selectType="selectAssemble"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
          :disabled="isDisableOrganization"
        />
        <global-select
          slot="supplierCode"
          ref="supplierCodeRef"
          :value.sync="queryParams.supplierCode"
          selectType="selectSearch"
          requestApi="/mdm/mdmOrgSupplier/supplierBox"
          :selectItem="{ value: 'bringOutDataOne', label: 'label' }"
          searchParam="supplierName"
        />
        <global-select
          slot="statusList"
          :value.sync="queryParams.statusList"
          :selectData="statusList"
          selectType="selectMultipleFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="lbjType"
          :value.sync="queryParams.lbjType"
          :selectData="lbjTypeList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="sourceType"
          :value.sync="queryParams.sourceType"
          :selectData="sourceTypeList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="gdStatus"
          :value.sync="queryParams.gdStatus"
          :selectData="gdStatusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" :loading="loading" v-hasPermi="['scp:scpPlanPurchaseOrder:downloadDemand']" @click="handleDownloadDemand">下载工单需求</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['scp:scpPlanPurchaseOrder:add']" @click="handleAdd">新增</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['scp:scpPlanPurchaseOrder:push']" :disabled="selectedRows.length < 1" @click="handleOrderPush">推单</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['scp:scpPlanPurchaseOrder:cancel']" :disabled="selectedRows.length < 1" @click="handleCancel">取消</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['scp:scpPlanPurchaseOrder:import']" @click="handleImport">导入</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['scp:scpPlanPurchaseOrder:export']" @click="handleExport">导出</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['scp:scpPlanPurchaseOrder:flush']" @click="handleRefreshSupplier">刷新供应商</a-button>
        <download-modal :apiFun="apiScpPlanPurchaseOrderExport" ref="download" />
        <add-purchase-modal ref="addPurchaseModalRef" @success="handleOk" />
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="() => handleOk(false)" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text ? $moment(data.text).format('YYYY-MM-DD') : '' }}
          </template>
          <template #demandDateTitle>
            <span>期望交货日期</span>
            <a-icon class="action-icon" type="edit" title="批量编辑" @click.stop="handleBatchEditDemandDate" />
          </template>
          <!-- 期望交货日期 -->
          <template slot="demandDate" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text ? $moment(text).format('YYYY-MM-DD') : '' }}</span>
            <a-date-picker :allowClear="false" v-else style="width: 100%" v-model="record.demandDate" valueFormat="YYYY-MM-DD 00:00:00" />
          </template>
          <!-- 下单数量 -->
          <template slot="purchaseQuantity" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input-number
              v-else
              style="width: 100%"
              v-model="record.purchaseQuantity"
              :min="0.01"
              :max="999999"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
            />
          </template>
          <!-- 供应商编码 -->
          <template slot="supplierCode" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              :allowClear="false"
              :dropdownMatchSelectWidth="false"
              :value.sync="record.supplierCode"
              selectType="selectAssembleSearch"
              searchParam="supplierName"
              requestApi="/scp/scpProductionScheduling/findSupplier"
              @change="(val, list) => handleSupplierChange(val, list, record)"
              :selectItem="{ value: 'lookUpCode', label: 'lookUpValue' }" />
<!--            <global-select
              v-else
              class="pub-select"
              :allowClear="false"
              v-model="record.supplierCode"
              selectType="selectAssembleFilter"
              :dropdown-match-select-width="false"
              requestApi="/scp/scpPlanPurchaseOrder/supplierList"
              :selectItem="{ value: 'supplierCode', label: 'supplierName' }"
              :setParams="{ orgCode: record.organizationCode, lbjType: record.lbjType }"
              @change="(val, list) => handleSupplierChange(val, list, record)"
            />-->
          </template>
          <span slot="operation" slot-scope="text">
            <a v-hasPermi="['scp:scpPlanPurchaseOrder:edit']" v-if="(!isEdit || currentId !== text.record.id) && ['NEW', 'PUSH_FAIL'].includes(text.record.status)" @click="handleEdit(text.record)">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleEditCancel(text.record)" class="ml10">取消</a>
            <a v-hasPermi="['scp:scpPlanPurchaseOrder:log']" class="ml10" @click="handleLog(text.record)">日志</a>
          </span>
        </ls-api-table>
      </div>
      <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      <batch-edit-demand-date-modal ref="batchEditDemandDateModalRef" @success="handleBatchEditDemandDateSuccess" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData, handleCopyFromExcel } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import cacheRequest from '@/mixins/cacheRequest'
import { mapState } from 'vuex'
import addPurchaseModal from './components/addPurchaseModal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import {
  apiGeneratePurchaseOrder,
  apiPlanPurchaseOrderList,
  apiScpPlanPurchaseOrderCancel,
  apiFlushPurchaseOrderSupplier,
  apiScpPlanPurchaseOrderEdit,
  apiScpPlanPurchaseOrderExport,
  apiScpPlanPurchaseOrderPush
} from '@/api/scp/purchase/purchaseApi'
import moment from 'moment'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import { apiGetLog } from '@/api/mes/productionPrepare/teamManage'
import BatchEditDemandDateModal from './components/batchEditDemandDateModal.vue'

export default {
  name: 'PurchaseOrderMaterial',
  components: { DownloadModal, addPurchaseModal, ImportExcel, OperationLogModel, BatchEditDemandDateModal },
  mixins: [cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'; // 林氏产业园库存组织可
    }
  },
  data() {
    return {
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      apiScpPlanPurchaseOrderExport,
      loading: false, // 请求loading
      isEdit: false,
      currentId: "",
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiPlanPurchaseOrderList, false),
        pageCurrent: true
      },
      // 用户导入参数
      upload: {
        url: () => process.env.VUE_APP_API_BASE_URL + `/scp/scpPlanPurchaseOrder/import?organizationCode=${this.organizationCodeOrigin}` // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'scp/scpPlanPurchaseOrder/template',
        name: `采购下单导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      statusList: [], // 状态列表
      lbjTypeList: [], // 零部件列表
      sourceTypeList: [], // 采购下单来源列表
      gdStatusList: [], // 工单状态列表
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        supplierCode: undefined,
        itemCode: undefined,
        demandDate: undefined,
        demandDateStart: undefined,
        demandDateEnd: undefined,
        wipEntityNameVal: undefined,
        statusList: ['NEW'], // 默认只显示新建的
        cpItemCode: undefined,
        gdStatus: undefined,
        purchaseNo: undefined,
        externalPurchaseNo: undefined,
        lbjType: undefined,
        sourceType: undefined,
        createTime: undefined,
        createTimeStart: undefined,
        createTimeEnd: undefined
      },
      formList: [
        { label: '加工厂', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '供应商', decorator: ['supplierCode'], type: 'supplierCode' },
        { label: '物料编码', decorator: ['itemCode'], type: 'input' },
        {
          label: '期望交货日期',
          type: 'range',
          decorator: ['demandDate'],
          disposeFormat: {
            demandDateStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            demandDateEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '工单号', decorator: ['wipEntityNameVal'], type: 'input' },
        { label: '状态', decorator: ['statusList'], type: 'statusList' },
        { label: '成品编码', decorator: ['cpItemCode'], type: 'input' },
        { label: '工单状态', decorator: ['gdStatus'], type: 'gdStatus' },
        { label: '采购需求行号', decorator: ['purchaseNo'], type: 'input' },
        { label: '采购单号', decorator: ['externalPurchaseNo'], type: 'input' },
        { label: '业务类型', decorator: ['lbjType'], type: 'lbjType' },
        { label: '来源类型', decorator: ['sourceType'], type: 'sourceType' },
        {
          label: '创建日期',
          type: 'range',
          decorator: ['createTime'],
          disposeFormat: {
            createTimeStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            createTimeEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        }
      ],
      // 表格字段
      columns: [
        { title: '工厂', dataIndex: 'organizationName', align: 'center', width: 160 },
        { title: '状态', dataIndex: 'statusName', align: 'center', width: 80 },
        { title: '采购需求行号', dataIndex: 'purchaseNo', align: 'center', width: 100 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 140 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 160, ellipsis: true },
        { title: '物料描述', dataIndex: 'specification', align: 'center', width: 160, ellipsis: true },
        { title: '工单需求数量', dataIndex: 'requiredQuantity', align: 'center', width: 95 },
        { title: '下单数量', dataIndex: 'purchaseQuantity', scopedSlots: { customRender: 'purchaseQuantity' }, align: 'center', width: 100 },
        { dataIndex: 'demandDate', scopedSlots: { customRender: 'demandDate', title: 'demandDateTitle' }, align: 'center', width: 140 },
        { title: '供应商编码', dataIndex: 'supplierCode', scopedSlots: { customRender: 'supplierCode' }, align: 'center', width: 130 },
        { title: '含税单价', dataIndex: 'taxUnitPrice', align: 'center', width: 100 },
        { title: '含税总价', dataIndex: 'totalTaxAndAmount', align: 'center', width: 100 },
        { title: '供应商名称', dataIndex: 'supplierName', align: 'center', width: 180 },
        { title: '单位', dataIndex: 'primaryUom', align: 'center', width: 80 },
        { title: '业务类型', dataIndex: 'lbjTypeName', align: 'center', width: 110 },
        { title: '工单号', dataIndex: 'wipEntityName', align: 'center', width: 140 },
        { title: '工单状态', dataIndex: 'gdStatusName', align: 'center', width: 100 },
        { title: '工单创建时间', dataIndex: 'gdCreateTime', align: 'center', width: 140 },
        { title: '计划完成时间', dataIndex: 'scheduledCompletionDate', align: 'center', width: 140 },
        { title: '成品编码', dataIndex: 'cpItemCode', align: 'center', width: 120 },
        { title: '成品名称', dataIndex: 'cpItemName', align: 'center', width: 100 },
        { title: '成品规格描述', dataIndex: 'cpSpecification', align: 'center', width: 160, ellipsis: true },
        { title: '工单套数', dataIndex: 'gdPlanQuantity', align: 'center', width: 90 },
        { title: 'BOM用量', dataIndex: 'quantityPerAssembly', align: 'center', width: 90 },
        { title: '采购单号', dataIndex: 'externalPurchaseNo', align: 'center', width: 90 },
        { title: '下推结果', dataIndex: 'pushResult', align: 'center', width: 200, ellipsis: true },
        { title: '来源类型', dataIndex: 'sourceTypeName', align: 'center', width: 100 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 90 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 90 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('SCP_PLAN_PURCHASE_ORDER_STATUS', { lookupType: 'SCP_PLAN_PURCHASE_ORDER_STATUS', current: 1, pageSize: 999 }, 'statusList')
    this.cacheLookupRequest('SCP_PLAN_PURCHASE_ORDER_LBJ_TYPE', { lookupType: 'SCP_PLAN_PURCHASE_ORDER_LBJ_TYPE', current: 1, pageSize: 999 }, 'lbjTypeList')
    this.cacheLookupRequest('SCP_PLAN_PURCHASE_ORDER_SOURCE_TYPE', { lookupType: 'SCP_PLAN_PURCHASE_ORDER_SOURCE_TYPE', current: 1, pageSize: 999 }, 'sourceTypeList')
    this.cacheLookupRequest('MES_JOB_STATUS', { lookupType: 'MES_JOB_STATUS', current: 1, pageSize: 999 }, 'gdStatusList')
  },
  mounted() {
    this.queryParams.organizationCode = this.organizationCodeOrigin
    this.onSearch()
  },
  methods: {
    // 取消(新建、已推单、推单失败状态可以取消)
    handleCancel() {
      const findNoAllow = this.selectedRows.find(item => !(['NEW', 'PUSH_FAIL', 'PUSH_SUCCESS'].includes(item.status)))
      if(findNoAllow) {
        this.$message.warning('请选择新建、已推单、推单失败的单据取消')
        return;
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: `确定取消勾选的单据吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          apiScpPlanPurchaseOrderCancel({ ids: self.selectedRows.map(item => item.id) }).then(res => {
            if (res?.code === 200) {
              self.$message.success('取消成功')
              self.handleOk(true)
            }
          }).finally(() => {
            self.loading = false
          })
        }
      })
    },
    handleRefreshSupplier() {
      const self = this
      self.$confirm({
        title: '提示',
        content: `${self.selectedRows?.length > 0 ? '确定对勾选的单据重新获取供应商吗？' : '确定对供应商为空的单据重新获取供应商吗？'}`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          const params = {}
          if(self.selectedRows?.length > 0) {
            params.ids = self.selectedRows.map(item => item.id)
          }else {
            params.organizationCode = self.queryParams.organizationCode
            if(!self.queryParams.organizationCode) {
              self.$message.warning('加工厂不能为空')
              return
            }
          }
          self.loading = true;
          apiFlushPurchaseOrderSupplier(params).then(res => {
            if (res?.code === 200) {
              self.$message.success('操作成功')
              self.handleOk(true)
            }
          }).finally(() => {
            self.loading = false
          })
        }
      })
    },
    // 推单
    handleOrderPush() {
      const findNoAllow = this.selectedRows.find(item => !(['NEW', 'PUSH_FAIL'].includes(item.status)))
      if(findNoAllow) {
        this.$message.warning('请选择待新增或推单失败的单据推单')
        return;
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: `确定推单勾选的单据吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          apiScpPlanPurchaseOrderPush({ ids: self.selectedRows.map(item => item.id) }).then(res => {
            if (res?.code === 200) {
              self.$message.success('推单成功')
              self.handleOk(true)
            }
          }).finally(() => {
            self.loading = false
          })
        }
      })
    },
    // 供应商选择
    handleSupplierChange(val, list, record) {
      if(val && list?.length > 0) {
        const getSupplier = list.find(item => item.lookUpCode === val)
        record.supplierName = getSupplier?.lookUpValue || ''
      }
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiGetLog({ id: row.id, type: 10 }).then(res => {
        if (res?.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 下载工单需求
    handleDownloadDemand() {
      this.loading = true;
      apiGeneratePurchaseOrder({ organizationCode: this.queryParams.organizationCode }).then(res => {
        if (res?.code === 200) {
          this.$message.success('下载工单需求成功')
          this.handleOk(true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleAdd() {
      this.$refs.addPurchaseModalRef.show(this.queryParams.organizationCode)
    },
    // 跳转到详情页面
    toDetails (record) {
      this.$router.push({ name: `MaterialReservationDetail`, query: { apptsNo: record.apptsNo } })
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 批量修改期望交货日期
    handleBatchEditDemandDate() {
      if (this.isEdit) {
        this.$message.warning('请先保存或取消当前单行编辑')
        return
      }
      if (this.selectedRows.length === 0) {
        this.$message.warning('请勾选单据进行操作')
        return
      }
      if (this.selectedRows.some(item => !['NEW', 'PUSH_FAIL'].includes(item.status))) {
        this.$message.warning('请选择待新增或推单失败的单据进行修改')
        return
      }
      this.$refs.batchEditDemandDateModalRef.show(this.selectedRows)
    },
    handleBatchEditDemandDateSuccess() {
      this.$message.success('修改完成')
      this.selectedRowKeys = []
      this.selectedRows = []
      this.handleOk(true)
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 保存
    handleSave(record) {
      if(!record?.purchaseQuantity) {
        this.$message.warning('请输入下单数量')
        return;
      }
      this.loading = true;
      apiScpPlanPurchaseOrderEdit(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('编辑成功')
          this.handleOk(true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 取消
    handleEditCancel() {
      this.handleOk(true)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false;
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      handleCopyFromExcel('wipEntityName', 'wipEntityNameList', params) // 物料编码支持excel的copy查询
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: this.organizationCodeOrigin,
        supplierCode: undefined,
        itemCode: undefined,
        demandDate: undefined,
        demandDateStart: undefined,
        demandDateEnd: undefined,
        wipEntityNameVal: undefined,
        statusList: undefined,
        cpItemCode: undefined,
        gdStatus: undefined,
        purchaseNo: undefined,
        externalPurchaseNo: undefined,
        lbjType: undefined,
        sourceType: undefined,
        createTime: undefined,
        createTimeStart: undefined,
        createTimeEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      if(this.$refs?.supplierCodeRef) this.$refs.supplierCodeRef.handleSearch('');
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.pub-select{
  /deep/ .ant-select{
    width: 100%;
  }
}
.action-icon{
  margin-left: 6px;
  color: #0486fe;
  cursor: pointer;
  font-size: 14px;
}
</style>
